<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center">
      <questions title="Estratégia" :items='questions' :key-form='keyForm'
        prev="/cliente/formulario" next="/diagnotico" />
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import Questions from './Questions';
import vButton from './vButton';

/* eslint-disable max-len */
export default {
  name: 'strategy-form',
  components: { Icon, Questions, vButton },
  data() {
    return {
      keyForm: 'strategy',
      questions: [
        { field: 'td_strategy_infra', title: 'A empresa possui estrutura para a implementação de novos processos digitais.' },
        { field: 'td_digital_first', title: 'Digital first: quando precisamos integrar meios digital e offline, normalmente a estratégia digital é adaptada e remodelada para o offline, e não o contrário.' },
        { field: 'td_measurement', title: 'Existem métricas bem definidas para a análise dos resultados de estratégias digitais.' },
        { field: 'td_security', title: 'A empresa tem a segurança digital como uma de suas prioridades.' },
        { field: 'td_team_readyness', title: 'Existe uma pessoa ou um time dedicado à Transformação Digital.' },
        { field: 'td_communication_clarity', title: 'A estratégia digital da empresa está clara para todos os colaboradores.' },
        { field: 'td_goal_solution', title: 'Buscam-se soluções e iniciativas digitais para o alcance de metas gerais da empresa.' },
        { field: 'td_data_unity', title: 'As informações e dados da empresa estão consolidadas em um único ambiente digital, que centraliza o conhecimento e documentos gerando ganho de eficiência.' },
      ],
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 5);
  },
  beforeDestroy() {
    this.$store.commit('CALCULATE_OVERALL')
  }
};
</script>



// WEBPACK FOOTER //
// src/components/StrategyForm.vue